import { Query } from '@varo/graphql-schema-types';
import GetCashbackTransactions from 'services/graphql/queries/GetCashbackTransactions';
import { useQuery } from 'urql';

const useCashbackTransactions = () => {
  const [{ data: cashbackTransactions, fetching: loading, error }] =
    useQuery<Query>({
      query: GetCashbackTransactions,
      requestPolicy: 'cache-and-network',
    });

  return {
    cashbackTransactions: cashbackTransactions?.myPartnerOffers?.cashback,
    loading,
    error,
  };
};

export default useCashbackTransactions;
